import * as React from 'react';
import styled from 'styled-components/macro';
import { FieldProps } from 'formik';
import Select from 'react-select';

import { Typography } from '@deeptrue-frontend/ui';

const StyledCustomSelect = styled.div`
  .react-select__control {
    padding: 0;
    outline: none;
    height: 50px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
    background-color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.sansSerif};
    font-size: ${({ theme }) => theme.fontSizes.copy1};
    color: ${({ theme }) => theme.colors.tuatara};
    margin-bottom: 1rem;

    &:hover {
      box-shadow: ${({ theme }) => theme.shadows.input};
    }
  }
`;

const CustomSelect = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}: FieldProps & {
  label: string;
  options: Array<{ value: string; label: string }>;
}) => {
  const { options } = props;
  return (
    <StyledCustomSelect>
      <label htmlFor={field.name}>
        <Typography
          variant="copy1"
          display="block"
          mb="1rem"
          color={errors[field.name] ? 'punch' : undefined}
        >
          {props.label}
        </Typography>
      </label>
      <Select
        {...field}
        {...props}
        classNamePrefix="react-select"
        options={options}
        value={
          (options
            ? options.find((option) => option.value === field.value)
            : '') as any
        }
        onChange={(option) => setFieldValue(field.name, (option as any).value)}
      />

      {touched[field.name] && errors[field.name] && (
        <p>{errors[field.name] as string}</p>
      )}
    </StyledCustomSelect>
  );
};

export default CustomSelect;
